<div class="block" [id]="idName"></div>
